import React from 'react';
import { useStyles } from './styles';
import { Typography, Tooltip, Switch } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import ChipMultiSelectWithDelete from '../../../Dropdowns/ChipMultiSelectWithDelete/ChipMultiSelectWithDelete';
import SettingsResetButton from "../SettingsResetButton";


const Form = ({
    handleFacilityChange, 
    toggle,
    onToggle,
    entityID,
    entityType,
    value,
    parentValue,
    handleResetChange,
    selectedFacilities,
    filteredGroupFacilities,
}) => {
    const classes = useStyles();
    const toolTipMsg = "Accept tickets from these other facilities";
    return (
        <div className={classes["shared-facilities-setting-container"]}>
            <div className={classes["shared-facilities-setting-header"]}>
                <Typography component="h6">Accepted Tickets</Typography> 
                <Tooltip title={toolTipMsg}>
                    <HelpIcon color='action' fontSize='small'/>
                </Tooltip>
                <Switch
                    name="sharedfacilities"
                    checked={toggle}
                    data-checked={toggle}
                    onChange={onToggle}
                    color="primary"
                />
                <SettingsResetButton
                    entityID={entityID}
                    entityType={entityType}
                    settingName="sharedfacilities"
                    currentValue={value}
                    originalValue={parentValue}
                    onClick={() => {
                        handleResetChange(
                            "sharedfacilities",
                            parentValue,
                        );
                    }}
                />
            </div>
            {toggle && (
                <ChipMultiSelectWithDelete
                key={value}
                className={classes.sharedFacilities}
                identifier="facilities"
                options={filteredGroupFacilities}
                onChange={handleFacilityChange}
                selected={selectedFacilities}
                placeholder={"Select facilities"}
                isError={false}
                disabled={filteredGroupFacilities?.length <= 0}
            />
            )}
        </div>
    );
}

export default Form;